import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { getToken, removeToken, setToken } from '../service/auth';
import api from '../service/api';
import Splash from '../components/Splash';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoading, setIstloading] = useState(true);
  const [user, setUser] = useState(null);
  const token = getToken();

  const refreshUser = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      return null;
    }
    try {
      const response = await api.get('/client/profile');
      const baseUser = response.data.user;
      setUser(baseUser);
      return baseUser;
    } catch (error) {
      console.error('Erro ao buscar perfil do usuário:', error);
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      if (token) {
        await refreshUser();
      } else if (active) {
        setUser(null);
      }
      if (active) setIstloading(false);
    })();
    return () => { active = false; };
  }, [token, refreshUser]);

  const login = async (user, token) => {
    try {
      setUser(user);
      setToken(token);
    } catch (error) {
      console.error('Erro ao fazer login:', error);
    }
  };

  const updateUser = async (data) => {
    const response = await api.put('/client/profile', data);
    const updated = response.data.user ?? { ...user, ...data };
    setUser(updated);
    return updated;
  };

  const logout = () => {
    removeToken();
    setUser(null);
  };

  if (isLoading) {
    return <Splash />;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
